/**
 * @generated SignedSource<<125da5639f7e2102358c9afee71d7279>>
 * @relayHash f94e0154d1407d259dba5bb6e81bd540
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 846bdae3aac3d1d3d3d0174d1e98719c7143a7d8535d6b324d003827c39b285f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamProfileCardEntryPointQuery$variables = {
  cloudId: string;
  teamId: string;
};
export type TeamProfileCardEntryPointQuery$data = {
  readonly team: {
    readonly teamV2: {
      readonly " $fragmentSpreads": FragmentRefs<"TeamProfileCardRelay_AtlassianTeamProfilecard">;
    } | null | undefined;
  } | null | undefined;
};
export type TeamProfileCardEntryPointQuery = {
  response: TeamProfileCardEntryPointQuery$data;
  variables: TeamProfileCardEntryPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamProfileCardEntryPointQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "teamV2",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "TeamProfileCardRelay_AtlassianTeamProfilecard"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamProfileCardEntryPointQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "teamV2",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "smallHeaderImageUrl"
              },
              {
                "kind": "ScalarField",
                "name": "smallAvatarImageUrl"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "isVerified"
              },
              {
                "kind": "ScalarField",
                "name": "state"
              },
              {
                "concreteType": "TeamMemberConnectionV2",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamMemberV2",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "member",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "846bdae3aac3d1d3d3d0174d1e98719c7143a7d8535d6b324d003827c39b285f",
    "metadata": {},
    "name": "TeamProfileCardEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c9412d7c2df6f5eec001d802dbedc65d";

export default node;
